import type { FechamentoEvento, FechamentoEventoStatus, MonitoramentoItem } from './models';

/** Chave AAAA-MM-DD no fuso local — a mesma usada pelas células do calendário. */
export const chaveDia = (d: Date): string =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

/** Data "AAAA-MM-DD" do prazo (ISO do backend). Prazo sem data válida retorna null. */
export const diaDoPrazo = (iso?: string | null): string | null => {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : chaveDia(d);
};

export const statusDoPrazo = (horasRestantes: number): FechamentoEventoStatus =>
  horasRestantes <= 0 ? 'ATRASADO' : horasRestantes < 24 ? 'EM_ANDAMENTO' : 'PENDENTE';

/** Prazos de SLA das conciliações como eventos do calendário, posicionados no dia do prazo. */
export const eventosDePrazos = (itens: MonitoramentoItem[]): FechamentoEvento[] =>
  itens.flatMap((i, idx): FechamentoEvento[] => {
    const data = diaDoPrazo(i.dataLimiteIso);
    if (!data) return [];
    return [{
      id: idx + 1,
      data,
      titulo: `Prazo N${i.nivel} — ${i.empresa}`,
      tipo: 'PRAZO_NIVEL',
      nivel: i.nivel,
      status: statusDoPrazo(i.horasRestantes),
      empresa: i.empresa,
      descricao: `${i.etapa} — Responsável: ${i.responsavel}`,
    }];
  });

/** Feriados nacionais (já sincronizados) como eventos do calendário. Ids negativos não colidem com os prazos. */
export const eventosDeFeriados = (feriados: { data: string; descricao: string; tipo?: string }[]): FechamentoEvento[] =>
  feriados.map((f, idx): FechamentoEvento => ({
    id: -(idx + 1),
    data: f.data.slice(0, 10),
    titulo: f.descricao || 'Feriado nacional',
    tipo: 'FERIADO',
    status: 'CONCLUIDO',
    empresa: 'Nacional',
    descricao: f.descricao || 'Feriado nacional',
  }));
